<app-search-cities-input
  *ngIf="mode === 'input'; else buttonTmp"
  mode="single"
  [textfieldSize]="textfieldSize"
  [ngModel]="currentCity$ | async"
  (ngModelChange)="onCityChange($event)"
>
  {{ 'components.citySwitcher.labels.inputText' | translate }}
</app-search-cities-input>

<ng-template #buttonTmp>
  <app-search-cities-button
    [size]="textfieldSize"
    [ngModel]="currentCity$ | async"
    (ngModelChange)="onCityChange($event)"
  ></app-search-cities-button>
</ng-template>
